import { CustomAction, DelayAction, EnableAction } from "./utilityActions";
import { TestCase } from "./testCase";
import { SceneGraphic, SceneGroup, TextSceneNode } from "../api/scene";
import { CenterSceneGroup, RowSceneGroup } from "../api/sceneGroup";
class BuyTestCase extends TestCase {
    constructor(parameterData) {
        super(parameterData);
        this._hatCount = 0;
        this._mittenCount = 0;
        //Data for model
        this._catCount = parameterData.catCount;
        this._hatMultiplier = parameterData.hatMultiplier;
        this._mittenMultiplier = parameterData.mittenMultiplier;
        this._hatCount = 0;
        this._mittenCount = 0;
        this._cats = new Array();
        const rowSceneGroup = new RowSceneGroup();
        for (let catIndex = 0; catIndex < this._catCount; catIndex++) {
            const catSceneGroup = new CatSceneGroup(this._hatMultiplier, this._mittenMultiplier);
            //catSceneGroup.x = 112 * catIndex;
            this._cats.push(catSceneGroup);
            rowSceneGroup.add(catSceneGroup);
        }
        this._overflowSceneGroup = new OverflowSceneGroup();
        rowSceneGroup.add(this._overflowSceneGroup);
        this._centerSceneGroup = new CenterSceneGroup();
        /*let fillSceneGraphic = new FillSceneGraphic(this.canvasWidth, this.canvasHeight, "#073642");
        this._centerSceneGroup.add(fillSceneGraphic);*/
        this._centerSceneGroup.width = this.canvasWidth;
        this._centerSceneGroup.height = this.canvasHeight;
        this._centerSceneGroup.add(rowSceneGroup);
    }
    static get millisecondsPerBuy() {
        return 250;
    }
    get sceneNode() {
        return this._centerSceneGroup;
    }
    get canvasWidth() {
        return 400;
    }
    get canvasHeight() {
        return 400;
    }
    get isSuccess() {
        return (this._hatCount == this._catCount * this._hatMultiplier &&
            this._mittenCount == this._catCount * this._mittenMultiplier);
    }
    buyHat(count) {
        this.dirty();
        for (let index = 0; index < count; index++) {
            const catIndex = Math.floor(this._hatCount / this._hatMultiplier);
            const hatIndex = this._hatCount - catIndex * this._hatMultiplier;
            this._hatCount++;
            if (catIndex < this._cats.length) {
                const hatSceneNode = this._cats[catIndex].getHat(hatIndex);
                this._actionQueue.add(new DelayAction(BuyTestCase.millisecondsPerBuy));
                this._actionQueue.add(new EnableAction(hatSceneNode, true));
            }
            else {
                this._actionQueue.add(new DelayAction(BuyTestCase.millisecondsPerBuy));
                this._actionQueue.add(new CustomAction(() => {
                    this._overflowSceneGroup.setHatsCount(this._hatCount - this._cats.length * this._hatMultiplier);
                }));
            }
        }
    }
    buyMitten(count) {
        this.dirty();
        for (let index = 0; index < count; index++) {
            const catIndex = Math.floor(this._mittenCount / this._mittenMultiplier);
            const mittenIndex = this._mittenCount - catIndex * this._mittenMultiplier;
            this._mittenCount++;
            if (catIndex < this._cats.length) {
                const mittenSceneNode = this._cats[catIndex].getMitten(mittenIndex);
                this._actionQueue.add(new DelayAction(BuyTestCase.millisecondsPerBuy));
                this._actionQueue.add(new EnableAction(mittenSceneNode, true));
            }
            else {
                this._actionQueue.add(new DelayAction(BuyTestCase.millisecondsPerBuy));
                this._actionQueue.add(new CustomAction(() => {
                    this._overflowSceneGroup.setMittensCount(this._mittenCount - this._cats.length * this._mittenMultiplier);
                }));
            }
        }
    }
    get styleSheet() {
        return `.buy-container {
      width: 100%;
      height: 100%;
      display: flex;
      direction: column;
      align-items: center;
      justify-content: center;
    }
    .buy-center {
      text-align: center;
    }
    .buy_value {
      border: 2px solid var(--color-base02);
    }`;
    }
}
export default BuyTestCase;
//ART!!!
// prettier-ignore
class MittenSceneNode extends SceneGraphic {
    constructor() {
        super();
        this._width = 13.236;
        this._height = 14.592;
    }
    onRender(ctx) {
        // #layer1
        // #path1115
        ctx.beginPath();
        ctx.fillStyle = 'rgb(223, 118, 72)';
        ctx.lineWidth = 1.490730;
        ctx.moveTo(12.849908, 3.266230);
        ctx.bezierCurveTo(12.849908, 3.822312, 12.399713, 4.272491, 11.845169, 4.272491);
        ctx.lineTo(1.393813, 4.272491);
        ctx.bezierCurveTo(0.837778, 4.272491, 0.387584, 3.822312, 0.387584, 3.266230);
        ctx.lineTo(0.387584, 1.006261);
        ctx.bezierCurveTo(0.387584, 0.450217, 0.837778, 0.000000, 1.393813, 0.000000);
        ctx.lineTo(11.845169, 0.000000);
        ctx.bezierCurveTo(12.399713, 0.000000, 12.849908, 0.450217, 12.849908, 1.006261);
        ctx.fill();
        // #g1123
        ctx.save();
        ctx.transform(1.490710, 0.000000, 0.000000, 1.490750, -258.116000, -69.543600);
        // #line1117
        ctx.beginPath();
        ctx.globalAlpha = 0.5;
        ctx.strokeStyle = 'rgb(231, 158, 79)';
        ctx.lineWidth = 0.674300;
        ctx.miterLimit = 10;
        ctx.moveTo(175.033000, 46.650002);
        ctx.lineTo(175.033000, 49.655998);
        ctx.stroke();
        // #line1119
        ctx.beginPath();
        ctx.globalAlpha = 0.5;
        ctx.strokeStyle = 'rgb(231, 158, 79)';
        ctx.lineWidth = 0.674300;
        ctx.miterLimit = 10;
        ctx.moveTo(177.590000, 46.650002);
        ctx.lineTo(177.590000, 49.655998);
        ctx.stroke();
        // #line1121
        ctx.beginPath();
        ctx.globalAlpha = 0.5;
        ctx.strokeStyle = 'rgb(231, 158, 79)';
        ctx.lineWidth = 0.674300;
        ctx.miterLimit = 10;
        ctx.moveTo(180.147000, 46.650002);
        ctx.lineTo(180.147000, 49.655998);
        ctx.stroke();
        ctx.restore();
        // #path1125
        ctx.beginPath();
        ctx.fillStyle = 'rgb(166, 73, 66)';
        ctx.lineWidth = 1.490730;
        ctx.moveTo(13.230037, 3.872995);
        ctx.bezierCurveTo(13.204678, 3.319899, 12.772390, 2.875653, 12.232754, 2.875653);
        ctx.lineTo(1.006228, 2.875653);
        ctx.bezierCurveTo(0.465101, 2.875653, 0.031305, 3.319899, 0.007454, 3.872995);
        ctx.lineTo(0.000000, 3.872995);
        ctx.lineTo(0.000000, 3.916082);
        ctx.lineTo(0.000000, 6.802205);
        ctx.lineTo(0.000000, 8.145373);
        ctx.bezierCurveTo(0.000000, 11.706897, 2.962038, 14.591470, 6.615764, 14.591470);
        ctx.bezierCurveTo(10.270982, 14.591470, 13.236000, 11.705385, 13.236000, 8.145486);
        ctx.lineTo(13.236000, 6.802318);
        ctx.lineTo(13.236000, 3.916195);
        ctx.lineTo(13.236000, 3.873108);
        ctx.fill();
    }
}
// prettier-ignore
class HatSceneNode extends SceneGraphic {
    constructor() {
        super();
        this._width = 19.007;
        this._height = 18.803;
    }
    onRender(ctx /*CanvasRenderingContext2D*/) {
        // #layer1
        // #path1129
        ctx.beginPath();
        ctx.fillStyle = 'rgb(166, 73, 66)';
        ctx.lineWidth = 1.479980;
        ctx.moveTo(19.000000, 16.994608);
        ctx.lineTo(19.000000, 7.223773);
        ctx.bezierCurveTo(19.000000, 3.235238, 15.764761, 0.000000, 11.773252, 0.000000);
        ctx.lineTo(7.223789, 0.000000);
        ctx.bezierCurveTo(3.235239, 0.000000, 0.000000, 3.235238, 0.000000, 7.223773);
        ctx.lineTo(0.000000, 16.994608);
        ctx.fill();
        // #g1133
        ctx.save();
        ctx.transform(1.479980, 0.000000, 0.000000, 1.479980, -222.813000, -64.632300);
        // #path1131
        ctx.beginPath();
        ctx.fillStyle = 'rgb(166, 73, 66)';
        ctx.moveTo(163.389000, 55.290000);
        ctx.bezierCurveTo(163.389000, 55.887000, 162.901000, 56.375000, 162.305000, 56.375000);
        ctx.lineTo(151.635000, 56.375000);
        ctx.bezierCurveTo(151.039000, 56.375000, 150.551000, 55.887000, 150.551000, 55.290000);
        ctx.lineTo(150.551000, 51.085000);
        ctx.bezierCurveTo(150.551000, 50.488000, 151.039000, 50.000000, 151.635000, 50.000000);
        ctx.lineTo(162.305000, 50.000000);
        ctx.bezierCurveTo(162.901000, 50.000000, 163.389000, 50.488000, 163.389000, 51.085000);
        ctx.fill();
        ctx.restore();
        // #rect1137
        ctx.beginPath();
        ctx.fillStyle = 'rgb(27, 31, 58)';
        ctx.lineWidth = 1.479980;
        ctx.rect(14.764282, 0.827351, 0.725191, 7.906060);
        ctx.fill();
        // #path1139
        ctx.beginPath();
        ctx.fillStyle = 'rgb(27, 31, 58)';
        ctx.lineWidth = 1.479980;
        ctx.moveTo(16.735629, 15.486539);
        ctx.lineTo(16.735629, 10.962217);
        ctx.bezierCurveTo(16.735629, 9.221745, 16.059277, 7.820220, 15.224568, 7.820220);
        ctx.lineTo(15.027730, 7.820220);
        ctx.bezierCurveTo(14.193021, 7.820220, 13.518149, 9.221745, 13.518149, 10.962217);
        ctx.lineTo(13.518149, 15.486539);
        ctx.fill();
    }
}
// prettier-ignore
class CatSceneNode extends SceneGraphic {
    constructor() {
        super();
        this._width = 100;
        this._height = 89.098;
    }
    onRender(ctx) {
        // #layer1
        // #rect833
        /*ctx.beginPath();
        ctx.fillStyle = 'rgb(166, 73, 66)';
        ctx.strokeStyle = 'rgb(0, 43, 54)';
        ctx.lineWidth = 0.049924;
        ctx.miterLimit = 4;
        ctx.rect(0.0, 0.0, 100, 100);
        ctx.fill();
        ctx.stroke();*/
        // #layer1
        // #path815
        ctx.save();
        ctx.beginPath();
        ctx.fillStyle = 'rgb(231, 158, 79)';
        ctx.lineWidth = 1.320910;
        ctx.moveTo(5.997676, 0.005222);
        ctx.bezierCurveTo(2.663420, -0.143198, 1.546541, 2.914706, 1.325783, 3.763049);
        ctx.bezierCurveTo(-0.059860, 9.095614, -0.409410, 14.785374, 0.515233, 20.573662);
        ctx.bezierCurveTo(1.599563, 27.345700, 4.284371, 33.466434, 8.120731, 38.616702);
        ctx.bezierCurveTo(6.555762, 41.767305, 5.671503, 45.315429, 5.671503, 49.071821);
        ctx.bezierCurveTo(5.671503, 54.666092, 7.626109, 59.802213, 10.884414, 63.841409);
        ctx.lineTo(10.884414, 83.907894);
        ctx.bezierCurveTo(10.884414, 86.774274, 13.205543, 89.097368, 16.071935, 89.097368);
        ctx.bezierCurveTo(18.938325, 89.097368, 21.261407, 86.774274, 21.261407, 83.907894);
        ctx.lineTo(21.261407, 71.235971);
        ctx.bezierCurveTo(23.745491, 72.127477, 26.421798, 72.614882, 29.212611, 72.614882);
        ctx.lineTo(34.282943, 72.614882);
        ctx.lineTo(34.282943, 83.907894);
        ctx.bezierCurveTo(34.282943, 86.774274, 36.606024, 89.097368, 39.472417, 89.097368);
        ctx.bezierCurveTo(42.337488, 89.097368, 44.661890, 86.774274, 44.661890, 83.907894);
        ctx.lineTo(44.661890, 72.614882);
        ctx.lineTo(57.681473, 72.614882);
        ctx.lineTo(57.681473, 83.907894);
        ctx.bezierCurveTo(57.681473, 86.774274, 60.005875, 89.097368, 62.870946, 89.097368);
        ctx.bezierCurveTo(65.736017, 89.097368, 68.062373, 86.774274, 68.062373, 83.907894);
        ctx.lineTo(68.062373, 72.614882);
        ctx.lineTo(76.458890, 72.614882);
        ctx.bezierCurveTo(78.040889, 72.614882, 79.585407, 72.455436, 81.080002, 72.157849);
        ctx.lineTo(81.080002, 83.907894);
        ctx.bezierCurveTo(81.080002, 86.774274, 83.404404, 89.097368, 86.269475, 89.097368);
        ctx.bezierCurveTo(89.135871, 89.097368, 91.460902, 86.774274, 91.460902, 83.907894);
        ctx.lineTo(91.460902, 67.216423);
        ctx.bezierCurveTo(96.677042, 62.898291, 100.000000, 56.373120, 100.000000, 49.071821);
        ctx.bezierCurveTo(100.000000, 48.954277, 99.983960, 48.839905, 99.982450, 48.722211);
        ctx.bezierCurveTo(99.985150, 48.604703, 100.000000, 48.491653, 100.000000, 48.372600);
        ctx.lineTo(100.000000, 32.829570);
        ctx.bezierCurveTo(100.000000, 31.192072, 99.767304, 29.613469, 99.369128, 28.101035);
        ctx.lineTo(96.605453, 6.018917);
        ctx.bezierCurveTo(96.424487, 4.576473, 95.444817, 4.245664, 94.427710, 5.282586);
        ctx.lineTo(85.984318, 13.874417);
        ctx.bezierCurveTo(85.742396, 14.120733, 85.559875, 14.406187, 85.429629, 14.712312);
        ctx.bezierCurveTo(84.143659, 14.430378, 82.811888, 14.270903, 81.441331, 14.270903);
        ctx.lineTo(70.851446, 14.270903);
        ctx.bezierCurveTo(69.725786, 14.270903, 68.626777, 14.383441, 67.556512, 14.575592);
        ctx.bezierCurveTo(67.441794, 14.326975, 67.292073, 14.088406, 67.081900, 13.874417);
        ctx.lineTo(58.638508, 5.282586);
        ctx.bezierCurveTo(57.620080, 4.245664, 56.628228, 4.575841, 56.435374, 6.016964);
        ctx.lineTo(53.909973, 24.878367);
        ctx.bezierCurveTo(53.888003, 25.041432, 53.882313, 25.188282, 53.884583, 25.325634);
        ctx.bezierCurveTo(53.853603, 25.395524, 53.817063, 25.462328, 53.786923, 25.532666);
        ctx.lineTo(29.212611, 25.532666);
        ctx.bezierCurveTo(23.511956, 25.532666, 18.283762, 27.559179, 14.210599, 30.931125);
        ctx.bezierCurveTo(12.006219, 27.425161, 10.444422, 23.440902, 9.749644, 19.095140);
        ctx.bezierCurveTo(8.994079, 14.364920, 9.351273, 9.724448, 10.579725, 5.399774);
        ctx.bezierCurveTo(10.882215, 4.343020, 10.868335, 1.255470, 7.566041, 0.280614);
        ctx.bezierCurveTo(6.995405, 0.112693, 6.473998, 0.026425, 5.997676, 0.005222);
        ctx.fill();
        ctx.restore();
        // #path4520
        ctx.save();
        ctx.beginPath();
        ctx.fillStyle = 'rgb(166, 73, 66)';
        ctx.lineWidth = 1.320910;
        ctx.moveTo(41.656482, 25.531640);
        ctx.lineTo(41.656482, 46.130416);
        ctx.bezierCurveTo(41.656482, 47.299442, 42.853545, 48.246480, 44.327691, 48.246480);
        ctx.bezierCurveTo(45.801830, 48.246480, 46.998895, 47.299442, 46.998895, 46.130416);
        ctx.lineTo(46.998895, 25.531640);
        ctx.fill();
        ctx.restore();
        // #path843
        ctx.save();
        ctx.beginPath();
        ctx.fillStyle = 'rgb(166, 73, 66)';
        ctx.lineWidth = 1.320910;
        ctx.moveTo(28.598031, 25.547300);
        ctx.bezierCurveTo(26.757575, 25.594440, 24.967667, 25.847343, 23.255621, 26.293839);
        ctx.lineTo(23.255621, 46.130416);
        ctx.bezierCurveTo(23.255621, 47.299442, 24.451362, 48.246480, 25.926826, 48.246480);
        ctx.bezierCurveTo(27.400971, 48.246480, 28.598031, 47.299442, 28.598031, 46.130416);
        ctx.fill();
        ctx.restore();
        // #path4517
        ctx.save();
        ctx.beginPath();
        ctx.fillStyle = 'rgb(166, 73, 66)';
        ctx.lineWidth = 1.320910;
        ctx.moveTo(32.456052, 25.531640);
        ctx.lineTo(32.456052, 46.130416);
        ctx.bezierCurveTo(32.456052, 47.299442, 33.651374, 48.246480, 35.125517, 48.246480);
        ctx.bezierCurveTo(36.600984, 48.246480, 37.796722, 47.299442, 37.796722, 46.130416);
        ctx.lineTo(37.796722, 25.531640);
        ctx.fill();
        ctx.restore();
        // #path855
        ctx.beginPath();
        ctx.fillStyle = 'rgb(27, 31, 58)';
        ctx.lineWidth = 1.320910;
        ctx.moveTo(70.264825, 26.825591);
        ctx.bezierCurveTo(70.264825, 28.073861, 69.255643, 29.085685, 68.007377, 29.085685);
        ctx.bezierCurveTo(66.756468, 29.085685, 65.747287, 28.073861, 65.747287, 26.825591);
        ctx.bezierCurveTo(65.747287, 25.579964, 66.756468, 24.568139, 68.007377, 24.568139);
        ctx.bezierCurveTo(69.255643, 24.568139, 70.264825, 25.578644, 70.264825, 26.825591);
        ctx.fill();
        // #circle861
        ctx.beginPath();
        ctx.fillStyle = 'rgb(27, 31, 58)';
        ctx.lineWidth = 1.320910;
        ctx.moveTo(85.781647, 24.589269);
        ctx.bezierCurveTo(87.027672, 24.589269, 88.037774, 25.599373, 88.037774, 26.845400);
        ctx.bezierCurveTo(88.037774, 28.091427, 87.027672, 29.101531, 85.781647, 29.101531);
        ctx.bezierCurveTo(84.535622, 29.101531, 83.525520, 28.091427, 83.525520, 26.845400);
        ctx.bezierCurveTo(83.525520, 25.599373, 84.535622, 24.589269, 85.781647, 24.589269);
        ctx.fill();
        // #path867
        ctx.beginPath();
        ctx.fillStyle = 'rgb(27, 31, 58)';
        ctx.lineWidth = 1.320910;
        ctx.moveTo(72.898734, 30.376223);
        ctx.bezierCurveTo(73.453519, 31.229538, 74.177382, 31.921700, 75.234116, 31.999634);
        ctx.bezierCurveTo(76.260470, 32.076244, 77.047736, 31.176702, 77.499489, 30.376223);
        ctx.bezierCurveTo(77.819151, 29.809549, 76.949988, 29.303637, 76.632967, 29.867670);
        ctx.bezierCurveTo(76.323873, 30.415852, 75.918351, 30.974600, 75.234116, 30.995736);
        ctx.bezierCurveTo(74.589508, 31.015546, 74.075671, 30.343201, 73.766577, 29.867670);
        ctx.bezierCurveTo(73.412571, 29.327414, 72.542086, 29.830680, 72.898734, 30.376223);
        ctx.fill();
        // #path873
        ctx.beginPath();
        ctx.fillStyle = 'rgb(27, 31, 58)';
        ctx.lineWidth = 1.320910;
        ctx.moveTo(76.631647, 30.376223);
        ctx.bezierCurveTo(77.186432, 31.229538, 77.910295, 31.921700, 78.967029, 31.999634);
        ctx.bezierCurveTo(79.993381, 32.076244, 80.780648, 31.176702, 81.232402, 30.376223);
        ctx.bezierCurveTo(81.552064, 29.809549, 80.684221, 29.303637, 80.365880, 29.867670);
        ctx.bezierCurveTo(80.056785, 30.415852, 79.651264, 30.974600, 78.967029, 30.995736);
        ctx.bezierCurveTo(78.322421, 31.015546, 77.808584, 30.341880, 77.499489, 29.867670);
        ctx.bezierCurveTo(77.145484, 29.327414, 76.275000, 29.830680, 76.631647, 30.376223);
        ctx.fill();
        // #line881
        ctx.beginPath();
        ctx.strokeStyle = 'rgb(27, 31, 58)';
        ctx.lineWidth = 0.660459;
        ctx.miterLimit = 10;
        ctx.moveTo(92.269981, 28.818857);
        ctx.lineTo(95.894577, 28.818857);
        ctx.stroke();
        // #line883
        ctx.beginPath();
        ctx.strokeStyle = 'rgb(27, 31, 58)';
        ctx.lineWidth = 0.660459;
        ctx.miterLimit = 10;
        ctx.moveTo(91.824837, 27.080524);
        ctx.lineTo(95.276390, 25.976238);
        ctx.stroke();
        // #line885
        ctx.beginPath();
        ctx.strokeStyle = 'rgb(27, 31, 58)';
        ctx.lineWidth = 0.660459;
        ctx.miterLimit = 10;
        ctx.moveTo(91.824837, 30.558510);
        ctx.lineTo(95.276390, 31.662800);
        ctx.stroke();
        // #line889
        ctx.beginPath();
        ctx.strokeStyle = 'rgb(27, 31, 58)';
        ctx.lineWidth = 0.660459;
        ctx.miterLimit = 10;
        ctx.moveTo(61.034260, 28.818857);
        ctx.lineTo(57.409660, 28.818857);
        ctx.stroke();
        // #line891
        ctx.beginPath();
        ctx.strokeStyle = 'rgb(27, 31, 58)';
        ctx.lineWidth = 0.660459;
        ctx.miterLimit = 10;
        ctx.moveTo(61.479397, 27.080524);
        ctx.lineTo(58.027851, 25.976238);
        ctx.stroke();
        // #line893
        ctx.beginPath();
        ctx.strokeStyle = 'rgb(27, 31, 58)';
        ctx.lineWidth = 0.660459;
        ctx.miterLimit = 10;
        ctx.moveTo(61.479397, 30.558510);
        ctx.lineTo(58.027851, 31.662800);
        ctx.stroke();
    }
}
class CatSceneGroup extends SceneGroup {
    constructor(hatMax, mittenMax) {
        super();
        const catSceneNode = new CatSceneNode();
        this.add(catSceneNode);
        this._hats = [];
        for (let hatIndex = 0; hatIndex < hatMax; hatIndex++) {
            const hatSceneNode = new HatSceneNode();
            hatSceneNode.x = 66.767;
            hatSceneNode.y = 0;
            hatSceneNode.enabled = false;
            this.add(hatSceneNode);
            this._hats.push(hatSceneNode);
        }
        const mittenX = [9.425, 32.725, 56.4, 79.7];
        const mittenY = [74.524, 74.524, 74.524, 74.524];
        this._mittens = [];
        for (let mittenIndex = 0; mittenIndex < mittenMax; mittenIndex++) {
            const mittenSceneNode = new MittenSceneNode();
            mittenSceneNode.x = mittenX[mittenIndex];
            mittenSceneNode.y = mittenY[mittenIndex];
            mittenSceneNode.enabled = false;
            this.add(mittenSceneNode);
            this._mittens.push(mittenSceneNode);
        }
    }
    getHat(index) {
        return this._hats[index];
    }
    getMitten(index) {
        return this._mittens[index];
    }
}
class OverflowSceneGroup extends SceneGroup {
    constructor() {
        super();
        this._hatCount = 0;
        this._hatTextSceneNode = new TextSceneNode("+0", "#839496", "18px Arial");
        this._hatTextSceneNode.enabled = false;
        this._hatTextSceneNode.x = 24;
        this._hatTextSceneNode.y = 0;
        this.add(this._hatTextSceneNode);
        this._hatSceneNode = new HatSceneNode();
        this._hatSceneNode.enabled = false;
        this._hatSceneNode.x = 0;
        this._hatSceneNode.y = 0;
        this.add(this._hatSceneNode);
        this._mittenCount = 0;
        this._mittenTextSceneNode = new TextSceneNode("+0", "#839496", "18px Arial");
        this._mittenTextSceneNode.enabled = false;
        this._mittenTextSceneNode.x = 24;
        this._mittenTextSceneNode.y = 74.524;
        this.add(this._mittenTextSceneNode);
        this._mittenSceneNode = new MittenSceneNode();
        this._mittenSceneNode.enabled = false;
        this._mittenSceneNode.x = 2.0275;
        this._mittenSceneNode.y = 74.524;
        this.add(this._mittenSceneNode);
    }
    setHatsCount(count) {
        console.log("setHatsCount: " + count);
        this._hatSceneNode.enabled = true;
        this._hatTextSceneNode.enabled = true;
        this._hatTextSceneNode.setText("+" + count.toString());
    }
    setMittensCount(count) {
        console.log("setMittensCount: " + count);
        this._mittenSceneNode.enabled = true;
        this._mittenTextSceneNode.enabled = true;
        this._mittenTextSceneNode.setText("+" + count.toString());
    }
}
